/*
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElRadioComponent } from './radio.component';
import { ElRadioGroupComponent } from './radio-group.component';


@NgModule({
  imports: [],
  exports: [ElRadioComponent, ElRadioGroupComponent],
  declarations: [ElRadioComponent, ElRadioGroupComponent],
})
export class ElRadioModule {
}
